import { Component } from "react";
import { Link, Navigate } from "react-router-dom";
import ErrorAlert from "../constantPages/Alerts/ErrorAlert";
import WarningAlert from "../constantPages/Alerts/WarningAlert";
import BCService from "../../services/BCService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";

class ListBCValidated extends Component {
  state = {
    // alert_message: "",
    // BC: [],

    alert_message: "",
    alert_message_inPayedBill: "",
    alert_message_PayedBill: "",
    alert_message_inPayedBD: "",
    alert_message_PayedBD: "",
    isEmptyPayedBills: false,
    isEmptyNotPayedBills: false,
    isEmptyBDCBills: false,
    bills: [],
    BC: [],
    billPayed: [],
  };
  constructor(props) {
    super(props);
    this.state = {
      // alert_message: "",
      // BC: [],

      alert_message: "",
      alert_message_inPayedBill: "",
      alert_message_PayedBill: "",
      alert_message_inPayedBD: "",
      alert_message_PayedBD: "",
      isEmptyPayedBills: false,
      isEmptyNotPayedBills: false,
      isEmptyBDCBills: false,
      bills: [],
      BC: [],
      billPayed: [],
    };
  }

  componentDidMount() {
    this.forceUpdate();
    localStorage.setItem("isIncome", this.props.isIncome);

    BCService.getBonDeCommandeByFilterForPayementTask(
      getCurrentUserId(), localStorage.getItem("idSociete"),
      localStorage.getItem("finalMonth"),
      localStorage.getItem("finalYear")
    )
      .then((response) => {
        console.log("response", response);
        if (response.data["success"] !== undefined) {
          this.setState({ BC: response.data["success"] });
        } else if (response.data["empty"] !== undefined) {
          this.setState({ isEmptyBDCBills: true });
        }
      })
      .catch((error) => {
        this.setState({ alert_message: "error" });

        this.setState({ alert_message_inPayedBD: "error" });
      });


  }
  addBillAchat() {
    return (
      <Link to="/addBCAchat">
        <button type="button" class="btn btn-success float-right">
          Ajouter un bon de commande
        </button>
      </Link>
    );
  }
  avanceLink() {
    return <Navigate replace to="/payerAvanceBC" />
  }
  factureLink() {
    return <Navigate replace to="/addBCBillAchat" />
  }
  detailsLink() {

    return <Navigate replace to="/payerAvanceBC" />
  }
  refreshPage() {
    window.location.reload();
  }

  listBonCommandes() {
    if (this.state.BC.length === 0) {
      return <div class="col-md-12"></div>;
    } else {
      return (
        <section class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title">Les Bon de commandes</h3>
                </div>
                <div class="card-body p-0">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>Bon de commande</th>
                        <th>Designation</th>
                        <th>Fournisseur</th>

                        <th>Montant Total</th>
                        <th>Avance payé</th>
                        <th>Payer une avance</th>

                        <th>Ajouter facture</th>
                        <th>Détails </th>
                        <th>Archiver</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.BC.map((bcom) => (
                        <tr>
                          <td>
                            {bcom.refBC}/{bcom.yearRefBC}-{bcom.title}
                          </td>
                          <td> {bcom.designation}</td>
                          <td> {bcom.societeCliente.title}</td>

                          <td> {bcom.amountTT}DNT </td>
                          <td> {bcom.amountPayed}DNT </td>
                          <td>
                            {" "}
                            <button
                              type="submit"
                              onClick={() => {
                                localStorage.setItem("idBC", bcom.id);
                                this.avanceLink()

                              }}
                              className="btn btn-info "
                            >
                              Avance
                            </button>
                          </td>
                          <td>
                            {" "}
                            <button
                              type="submit"
                              onClick={() => {
                                localStorage.setItem("idBC", bcom.id);
                                this.factureLink()
                              }}
                              className="btn btn-success "
                            >
                              Facture
                            </button>
                          </td>
                          <td>
                            {" "}
                            <button
                              type="submit"
                              onClick={() => {
                                localStorage.setItem(
                                  "idBC",
                                  bcom.id
                                );
                                this.detailsLink()
                              }}
                              className="btn btn-warning "
                            >
                              Détails
                            </button>
                          </td>

                          <td>
                            {" "}
                            <button
                              // type="submit"
                              onClick={(e) => {
                                if (
                                  window.confirm(
                                    "Voulez vous supprimer le bon de commande? "
                                  )
                                ) {
                                  this.deleteBC(bcom.bonCommande.id);
                                }
                              }}
                              className="btn btn-danger pull-center"
                            >
                              Supprimer
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    }
  }

  deleteBC(idBC) {
    BCService.deleteBCDraft(idBC)
      .then((response) => {
        console.log("response", response.data["BC"]);
        if (response.data["Bill"] === "not deleted") {
          this.setState({ alert_message: "error" });
        } else {
          this.setState({ alert_message: "success" });
          this.refreshPage();
        }
      })
      .catch((error) => {
        this.setState({ alert_message: "error" });
      });
  }
  render() {
    if (this.state.alert_message === "error" || this.state.BC.length === 0) {
      return (
        <div className="content-wrapper">
          <br />
          <section class="content">
            {/* {this.addBillAchat()} */}
            <br />
            <br />
            <div class="row">
              <div class="col-md-12">
                <WarningAlert message="Aucun Bon de commande à afficher" />
              </div>
            </div>
          </section>
        </div>
      );
    } else {
      return (
        <div className="content-wrapper">
          <br />
          {/* {this.addBillAchat()} */}
          {/* <section class="content"> */}
          <br />
          <br />
          <br />
          {this.listBonCommandes()}
          {/* </section> */}
          <br />
        </div>
      );
    }
  }
}
export default ListBCValidated;
